import { Table as CommonTable } from '@aslanpay/portal-common-lib';

import BulkActions from './BulkActions';

import type { TableProps } from './Table.types';

export function Table<TData extends object>(props: TableProps<TData>) {
  const { bulkActions, bulkActionsType, ...rest } = props;

  return (
    <CommonTable {...rest}>
      {(table) =>
        bulkActions &&
        bulkActionsType &&
        table.getSelectedRowModel().flatRows.length > 0 && (
          <BulkActions
            selectedRows={table.getSelectedRowModel().flatRows}
            actions={bulkActions}
            type={bulkActionsType}
          />
        )
      }
    </CommonTable>
  );
}
